import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { MembershipEventResponse } from '~/api/model';

// Response 타입은 Zod Model(MembershipEventResponse) 재사용 — OAISchema 금지 (api-typegen §0)

export interface MembershipEventDataSource {
  // 플러스 멤버십 주간 이벤트 정보
  getPlusMembershipEvent(): Promise<MembershipEventResponse>;
}

export class MembershipEventDataSourceImpl
  implements MembershipEventDataSource
{
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getPlusMembershipEvent() {
    return this.client.request<MembershipEventResponse>({
      url: '/api/market-place/v1/event/plus-membership-discount',
      method: 'get',
    });
  }
}

export const membershipEventDataSource = new MembershipEventDataSourceImpl();
